var React = require('react');
var ReactIntl = require('react-intl');
var injectIntl = ReactIntl.injectIntl;
var IntlProvider = ReactIntl.IntlProvider;
var AppConstants = require('../../constants/AppConstants')
var TOTPWidget = require('../TOTPWidget/TOTPWidget');
var WebAuthnWidget = require('../WebAuthnWidget/WebAuthnWidget');

class TwoFactorAuthenticationRenderer extends React.Component {
    constructor(props) {
        super(props);

        this.state= {
            showMFAMethodsBox: false,
            showTryOtherLink: props.showTryOtherLink || false,
            showTOTPControl: props.twoFaAuthMethod,
            credentialId: props.credentialId || '',
            authMethodDeviceName: props.authMethodDeviceName || '',
            userMFAMethods: props.userMFAMethods || []
        };

        this.setAuthenticationMethodOnClick= this.setAuthenticationMethodOnClick.bind(this);
        this.showMFAMethods= this.showMFAMethods.bind(this);
    }

    showMFAMethods() {
        const showMFAMethodsBox= this.state.showMFAMethodsBox;
        this.setState({showMFAMethodsBox: !showMFAMethodsBox});
    }

    setAuthenticationMethodOnClick(authMethodItem) {
        this.setState({
            showTOTPControl: authMethodItem.authenticationMethod, 
            showMFAMethodsBox: false,
            credentialId: authMethodItem.credentialId,
            authMethodDeviceName: authMethodItem.name
        });
    }

    renderWebAuthnForm() {
        return (
            <WebAuthnWidget
                {... this.props}
                phone={this.props.phone}
                emailId={this.props.emailId}
                login={this.props.login}
                idToken={this.props.idToken}
                credentialId= {this.state.credentialId}
                directOtpRedirectUri={this.props.directOtpRedirectUri}
                twoFaAuthMethod= {this.state.showTOTPControl}
                authMethodDeviceName= {this.state.authMethodDeviceName}
                userId={this.props.userId}
                userMFAMethods= {this.state.userMFAMethods}
                showMFAMethodsBox= {this.state.showMFAMethodsBox}
                showTryOtherLink= {this.state.showTryOtherLink}
                showMFAMethods= {this.showMFAMethods}
                setAuthenticationMethodOnClick= {this.setAuthenticationMethodOnClick}
            />
        );
    }

    renderTOTPForm() {
        return (
            <TOTPWidget
                {... this.props}
                phone={this.props.phone}
                emailId={this.props.emailId}
                login={this.props.login}
                idToken={this.props.idToken}
                directOtpRedirectUri={this.props.directOtpRedirectUri}
                twoFaAuthMethod= {this.state.showTOTPControl}
                authMethodDeviceName= {this.state.authMethodDeviceName}
                userMFAMethods= {this.state.userMFAMethods}
                showMFAMethodsBox= {this.state.showMFAMethodsBox}
                showTryOtherLink= {this.state.showTryOtherLink}
                showMFAMethods= {this.showMFAMethods}
                setAuthenticationMethodOnClick= {this.setAuthenticationMethodOnClick}/>
        );
    }

    render() {
        return (
            <div>{this.state.showTOTPControl === AppConstants.TWO_FA_WEB_AUTHN ? this.renderWebAuthnForm() : this.renderTOTPForm()}</div>
        );
    }
}

module.exports= injectIntl(TwoFactorAuthenticationRenderer);